import React from 'react';
import { Container } from '@michelin/acid-components';
import { usePermissions, useTranslation } from '@michelin/central-provider';
import { PlainMessage } from 'components/Messages';
import { PageTitle } from 'components/v3/PageTitle/PageTitle';
import { MechanicalList } from 'modules/Mechanical/List';

export function MechanicalModule() {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const urbanOnlyFleet = !!(
    permissions.location &&
    permissions.location.is_urban &&
    !permissions.location.is_commercial &&
    !permissions.location.override_is_commercial
  );
  const canViewMechanical =
    !urbanOnlyFleet && permissions.allowsAction('mechanicals.list') && permissions.allowsAction('mechanicals.read');
  return (
    <>
      <PageTitle
        eyebrow={t('Preferences')}
        title={t('Mechanical Preferences')}
        subtitle={t('Manage Preferences for Mechanical Services.')}
      />
      <Container>
        {canViewMechanical ? (
          <MechanicalList />
        ) : (
          <PlainMessage
            title={t('Mechanical Preferences unavailable')}
            messages={[t('Your account does not have permission to view mechanical preferences.')]}
          />
        )}
      </Container>
    </>
  );
}
